angular.module('bribac.entities.insuranceSubscriberFactory', [])
    .value('insuranceSubscriberFactory', function insuranceSubscriberFactory(data) {
        return angular.merge({
            lastName: null,
            firstName: null,
            middleName: null,
            city: null,
            state: null,
            zip: null,
            dateOfBirth: null,
            gender: null,
            mainGroupsIds: []
        }, data)
    })
